
import { getRequestLanguage } from '@/api/utils'
import { OpenAppEnum } from './types'
import { PropType, Ref, computed } from 'vue'
import { Button } from 'vant'

interface IHeaderState {
  onBtnClick: () => void
  language: Ref<string>
}

export default {
  components: {
    [Button.name as string]: Button
  },
  props: {
    background: {
      type: String as PropType<string>
    },
    btnBackground: {
      type: String as PropType<string>
    },
    btnTextColor: {
      type: String as PropType<string>
    },
    isShowBtn: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    headerLogo: {
      type: String as PropType<string>,
      default: ''
    },
    headerNameLogo: {
      type: String as PropType<string>,
      default: ''
    },
    buttonText: {
      type: String as PropType<string>,
      default: '下载App'
    },
    handleOpenApp: {
      type: Function as PropType<(position: OpenAppEnum) => void>,
      required: true
    },
    fixed: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    width: {
      type: String as PropType<string>,
      default: ''
    },
    height: {
      type: String as PropType<string>,
      default: ''
    }
  },
  setup(props: Readonly<{
    handleOpenApp: (position: OpenAppEnum) => void
  }>): IHeaderState {
    const onBtnClick = () => {
      props.handleOpenApp(OpenAppEnum.DOWNLOAD)
    }
    const language = computed(() => {
      return getRequestLanguage()
    })
    return {
      onBtnClick,
      language
    }
  }
}
